export default __webpack_public_path__ + "static/media/skills.e75861a0.svg";